import React, { createContext, useContext, useState } from 'react';
import { ClientIntakeModal } from './ClientIntakeModal';

const ModalContext = createContext();

export const useClientIntakeModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useClientIntakeModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [isClientIntakeOpen, setIsClientIntakeOpen] = useState(false);

  const openClientIntake = () => setIsClientIntakeOpen(true);
  const closeClientIntake = () => setIsClientIntakeOpen(false);

  return (
    <ModalContext.Provider value={{ openClientIntake, closeClientIntake }}>
      {children}
      <ClientIntakeModal isOpen={isClientIntakeOpen} onClose={closeClientIntake} />
    </ModalContext.Provider>
  );
};
